import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../ui/dialog";

interface ConfirmSendMailDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: string;
    onConfirm: () => void;
    confirmText?: string;
    cancelText?: string;
}

const ConfirmSendMailDialog = ({
    isOpen,
    onOpenChange,
    title,
    description,
    onConfirm,
    confirmText,
    cancelText,
}: ConfirmSendMailDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog onOpenChange={onOpenChange} open={isOpen}>
            <DialogContent className="w-min justify-center gap-5 px-20">
                <DialogHeader className="items-center gap-2">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter className="sm:justify-center">
                    <Button
                        onClick={() => onOpenChange(false)}
                        variant="outline"
                    >
                        {cancelText || t("email.warnings.cancel")}
                    </Button>
                    <Button onClick={onConfirm}>
                        {confirmText || t("email.warnings.accept")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmSendMailDialog;
